export default "__VITE_ASSET__C9ULH4FN__"